import { useQuery } from '@tanstack/react-query';
import { getVerificationQuestionaries } from '../requests';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

const useVerificationQuestionaries = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['verification-questionaries'],
    queryFn: getVerificationQuestionaries,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    questionaries: data,
    isQuestionariesLoading: isLoading,
    questionariesError: error,
  };
};

export { useVerificationQuestionaries };
